import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArchiveLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5858 3C17.1162 3 17.6249 3.21071 18 3.58579L20.4142 6C20.7893 6.37507 21 6.88378 21 7.41421V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V7.41421C3 6.88378 3.21071 6.37507 3.58579 6L6 3.58579C6.37507 3.21071 6.88378 3 7.41421 3H16.5858ZM19 9H5V19H19V9ZM12 10C12.5523 10 13 10.4477 13 11V14.1858L13.4142 13.7716C13.8047 13.381 14.4379 13.381 14.8284 13.7716C15.219 14.1621 15.219 14.7953 14.8284 15.1858L12.7071 17.3071C12.5196 17.4946 12.2652 17.6 12 17.6C11.7348 17.6 11.4804 17.4946 11.2929 17.3071L9.17157 15.1858C8.78105 14.7953 8.78105 14.1621 9.17157 13.7716C9.5621 13.381 10.1953 13.381 10.5858 13.7716L11 14.1858V11C11 10.4477 11.4477 10 12 10ZM16.5858 5H7.41421L5.41421 7H18.5858L16.5858 5Z"
	})
});
export default SvgArchiveLine;
